export const stripeElementOptions = {
  style: {
    base: {
      color: 'black',
      letterSpacing: '0.025em',
      '::placeholder': {
        color: '#aab7c4',
        opacity: '0.5',
        fontSize: '15px',
      },
      iconColor: '#c4f0ff',
      fontWeight: '500',
      fontSize: '16px',
      ':-webkit-autofill': {
        color: '#fce883',
      },
      fontFamily: 'Montserrat',
    },
    invalid: {
      color: '#9e2146',
    },
  },
}
